/**
 * Convenience hook for auditor-only role detection.
 *
 * `isAuditorOnly` is true when the user has the Auditor role
 * but does NOT have any admin roles (TenantAdmin, Admin, Organization.Admin, System.Admin).
 * This is used to restrict mutation actions and filter navigation.
 */
import { useAuth, hasAnyRole, isAdmin } from '../features/authentication';

export function useIsAuditor(): { isAuditorOnly: boolean } {
  const { user } = useAuth();

  if (!user?.roles) return { isAuditorOnly: false };

  const hasAuditor = hasAnyRole(user.roles, ['Auditor']);
  const hasAdmin = isAdmin(user.roles);

  return { isAuditorOnly: hasAuditor && !hasAdmin };
}
